var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecifiersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.032,
    height: 30.008,
    viewBox: "0 0 30.032 30.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-drafting-compass",
    "data-name": "Icon awesome-drafting-compass",
    d: "M25.885,19.508a17.945,17.945,0,0,1-4.675,2.778l3.08,5.335,3.056,1.3A.906.906,0,0,0,28.6,28.2l.4-3.3-3.114-5.394Zm2.407-5.356a.909.909,0,0,0-.343-1.268L26.359,12a.908.908,0,0,0-1.2.324,12.7,12.7,0,0,1-10.655,5.8,12.594,12.594,0,0,1-3.931-.653l3.815-6.609c.04,0,.076.012.116.012s.076-.011.116-.012l2.894,5.013A10.789,10.789,0,0,0,22.187,13.1L19.254,8.024a5.367,5.367,0,0,0,.683-2.586,5.437,5.437,0,0,0-10.875,0,5.373,5.373,0,0,0,.683,2.586l-3.868,6.7a12.664,12.664,0,0,1-1.908-2.209.908.908,0,0,0-1.211-.3l-1.572.91A.908.908,0,0,0,.867,14.4a16.252,16.252,0,0,0,3.171,3.513L0,24.9l.4,3.3a.906.906,0,0,0,1.256.725l3.056-1.3,4.01-6.946A16.258,16.258,0,0,0,14.5,21.75,16.336,16.336,0,0,0,28.292,14.152ZM14.5,3.625a1.812,1.812,0,1,1-1.812,1.812A1.813,1.813,0,0,1,14.5,3.625Z",
    transform: "translate(0.516 0.5)",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecifiersIcon);
export default __webpack_public_path__ + "static/media/specifiers-icon.130e221359afde1ccdeb4de2e1adaa3b.svg";
export { ForwardRef as ReactComponent };